import * as React from 'react';

import { ChakraProvider } from '@chakra-ui/react';
import { Analytics } from '@vercel/analytics/react';
import { LanguageProvider } from './Language';

export const RootLayout = ({ children }) => (
  <ChakraProvider>
    <LanguageProvider>{children}</LanguageProvider>
    <Analytics />
  </ChakraProvider>
);
